// src/context/AuthContext.js
import { createContext, useContext, useEffect, useState } from "react";
import Loader from '../Utils/Loader/Loader'
const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loggedIn = localStorage.getItem("IsLoggedIn") === "1";
    setIsLoggedIn(loggedIn);
    setLoading(false);
  }, []);

  return (
    <AuthContext.Provider value={{ isLoggedIn, setIsLoggedIn, loading }}>
      {loading ? <Loader/> : children} 
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
